import script from "./Map2dIcon.vue?vue&type=script&setup=true&lang=js"
export * from "./Map2dIcon.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__